import { api } from '../api-client.config';
import { MatchType } from 'src/types/domain.types';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { useGetMatchesQuery } from '../matches/getMatches';

type CreateMatchProps = Omit<MatchType, 'match_id'>;

const createMatch = async (data: CreateMatchProps) =>
  api.post('/matches', data);

export const useCreateMatchMutation = () => {
  const { refetch } = useGetMatchesQuery();

  return useMutation({
    mutationKey: ['matches'],
    mutationFn: createMatch,
    onSuccess: () => {
      toast.success('Match created successfully');
      refetch();
    },
    onError: (error) => {
      Promise.reject(error);
    },
  });
};
